export default class LottieFiles {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        $(window).on('load', () => {
            $('body').addClass('overflow-hidden');
            
            $('.js-loading-animation').fadeOut(300, () => {
                $('body').removeClass('overflow-hidden');
            });
        });

    }

};

new LottieFiles();
